const React = require('react');
const CircularProgress = require('@material-ui/core/CircularProgress').default;
const CheckIcon = require('@material-ui/icons/Check').default;
const ErrorIcon = require('@material-ui/icons/ErrorOutline').default;
const withState = require('../../../../../utils/withState');
const Ripple = require('../../../Ripple');
const useFormCtx = require("../../utils/useFormCtx");

const icons = {
  preUpload: () => (
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M32.5833 22.9998L23 32.5832L32.5833 22.9998ZM23 32.5832L13.4167 22.9998L23 32.5832ZM23 32.5832L23 7.6665L23 32.5832Z" fill="black"/>
        <path d="M32.5833 22.9998L23 32.5832M23 32.5832L13.4167 22.9998M23 32.5832L23 7.6665" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M34.5 38.333L11.5 38.333L34.5 38.333Z" fill="black"/>
        <path d="M34.5 38.333L11.5 38.333" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  ),
  loading: () => <CircularProgress className="(c0)>.MuiCircularProgress-svg" />,
  verified: () => <CheckIcon className="(w34|h34|c0).MuiSvgIcon-root" />,
  failed: () => <ErrorIcon className="(w34|h34|c0).MuiSvgIcon-root" />
}

module.exports = withState((setState, self) => {
  const MAX_FILE_SIZE = 16;
  return (state, props) => {
    const {
      loading,
    } = state;

    const {
      id,
      name,
      value = {},
      onChange,
      disabled,

      textProps = {},
      apiUpload,
    } = useFormCtx(props);

    let showError = false;
    let isRequired = true;
    const errorsFields = ['id', 'lifeflow_status'];
    const formCtx = props.formCtx;

    if (formCtx) {
      const formState = (formCtx || {}).state || {};
      const click = formState.click;

      showError = click && errorsFields.some((key) => {
        const errors = formState.errors || {};
        return errors[`${name}.${key}`];
      });

      // const schema = ((formCtx || {}).props || {}).schema;
      //
      // if (schema) {
      //   const schemaData = ((schema.default || {}).fields || {})[name] || {};
      //   const uploadIdField = (schemaData.fields || {}).id || {};
      //
      //   // isRequired = (uploadIdField.exclusiveTests || {}).hasOwnProperty('required')
      // }

    }

    const {lifeflow_status, file_name} = (value || {});

    const isVerified = lifeflow_status === 'completed';
    const isDenied = lifeflow_status === 'failed';
    const isSizeError = lifeflow_status === 'sizeError';

    let iconKey = 'preUpload';

    if (loading) {
      iconKey = 'loading';
    } else if (isVerified) {
      iconKey = 'verified';
    } else if (isDenied || isSizeError) {
      iconKey = 'failed';
    }

    const Icon = icons[iconKey];

    return (
      <Ripple
        className={`
          btn-upload w mt12 mb18
          (w|h112|layoutRow|aiC|ph26|b1|bs|bc0|r9)>.btn-upload__content
          (w46|h46|layoutRow|jcC|aiC|mr24)>.btn-upload__icon
          (dB)>.btn-upload__icon>svg
          (f12)>.btn-upload__text
          (fw7)>.btn-upload__title
          (mt11|fw3|lh17)>.btn-upload__desc
          (dN)>.btn-upload__input
          (bcF00).error>.btn-upload__content
          (o50).disabled
        `
          + (isVerified && !showError ? ' verified' : '')
          + (showError || (showError && isDenied) ? ' error' : '')
          + (disabled ? ' disabled' : '')
        }
        onClick={() => document.getElementById(name).click()}
        disabled={disabled}
      >
        <div className="btn-upload__content">
          <div className="btn-upload__icon">
            <Icon />
          </div>
          <div className="btn-upload__text">
            <div className="btn-upload__title">
              {textProps.title}{isRequired ? ' *' : ''}
            </div>
            <div className="btn-upload__desc">
              {isSizeError
                ? `Maximum size is ${MAX_FILE_SIZE}mb`
                : isDenied
                  ? 'Document was denied during verification'
                  : isVerified
                    ? file_name
                      ? `Document ${file_name} was successfully verified`
                      : `Document uploaded and verified`
                : textProps.desc
              }
            </div>
          </div>
        </div>
        <input
          id={name}
          type="file"
          className="btn-upload__input"
          accept="image/png, image/jpg, image/jpeg, application/pdf"
          onChange={(e) => {
            const file = e.target.files[0];

            if (!file) return;

            setState({loading: true});

            const fileSize = (file.size / (1024*1024)).toFixed(2)

            if (fileSize > MAX_FILE_SIZE) {
              onChange(
                name,
                {
                  id: '',
                  file_name: file.name,
                  lifeflow_status: 'sizeError',
                }
              );
              setState({loading: false});

              return;
            }

            apiUpload({data: e.target.files[0], docType: name}).promise
                .then((res) => {
                  const data = res.id;
                  onChange(
                    name,
                    {
                      id: data.id,
                      file_name: file.name,
                      lifeflow_status: data.lifeflow_status,
                    }
                  );
                })
                .finally(() => {
                  setState({loading: false});
                });
          }}
        />
      </Ripple>
    )
  }
})
